import { objectToQueryString } from "../helpers/ApiHelper";
import { ISearchInvoice } from "../models/IInvoice";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class InvoiceAdminsistrationApi extends ApiClient {

    approveInvoice(invoiceId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/invoiceAdminsistration/approve/${invoiceId}`, undefined, success, error, final);
    }

    attestInvoice(invoiceId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/invoiceAdminsistration/attest/${invoiceId}`, undefined, success, error, final);
    }

    approveInvoices(searchParams: ISearchInvoice, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/invoiceAdminsistration/approveInvoices`, searchParams, success, error, final);
    }

    attestInvoices(searchParams: ISearchInvoice, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/invoiceAdminsistration/attestInvoices`, searchParams, success, error, final);
    }
}